import { defineMessages } from 'react-intl';

export default defineMessages({
  REMAINING_TIME: {
    defaultMessage: 'Temps restant',
  },
  AVAILABLE_FROM: {
    defaultMessage: 'Disponible dans',
  },
  TIME: {
    defaultMessage: `{count, plural,
    one {# jour}
    other {# jours}
  }`,
  },
  REMAINING_TIME_COUNTDOWN: {
    defaultMessage: `{count} {unit, select,
    second {{count, plural,
      one {seconde}
      other {secondes}
    }}
    minute {{count, plural,
      one {minute}
      other {minutes}
    }}
    hour {{count, plural,
      one {heure}
      other {heures}
    }}
    day {{count, plural,
      one {jour}
      other {jours}
    }}
    other {{unit}}
  }`,
  },
  LABEL: {
    defaultMessage: `Accomplis {count, plural,
    one {cette action}
    other {ces # actions}
  } pour obtenir ton badge{credits, select,
    0 {}
    other { et {credits, plural,
      one {1 crédit}
      other {# crédits}
    }}
  } !`,
  },
  IS_UNDERSTOOD: {
    defaultMessage: 'Compris',
  },
} as const);
